<div class="sidebar-group mat-elevation-z1">
  <button
    aria-label="load root archives"
    mat-icon-button
    (click)="loadRootArchives()"
  >
    <mat-icon>inventory_2</mat-icon>
  </button>
  <span transloco="ARCHIVES"></span>
  <span class="spacer"></span>
  @if (inChildArchive) {
    <button
      mat-icon-button
      (click)="loadParentArchives()"
      [matTooltip]="breadcrumbString"
      matTooltipShowDelay="1000"
      matTooltipPosition="right"
    >
      <mat-icon>navigate_before</mat-icon>
    </button>
  }
  @if (rootSearches$ | async; as searches) {
    @if (searches.length > 0 && !inChildArchive) {
      <button
        mat-icon-button
        aria-label="Root archive searches"
        [matMenuTriggerFor]="rootSearchesMenu"
        (click)="$event.stopPropagation()"
      >
        <mat-icon>search</mat-icon>
      </button>
    }
    <app-navigation-expansion-button
      [isExpanded]="(isExpanded$ | async) === true"
      (isExpandedChange)="onExpandChanged()"
    ></app-navigation-expansion-button>
    <mat-menu #rootSearchesMenu="matMenu">
      @for (search of searches; track search) {
        <button (click)="clickSearch(search)" mat-menu-item>
          <mat-icon>search</mat-icon>
          <span>{{ search.name }}</span>
        </button>
      }
    </mat-menu>
  }
</div>
@if (isArchivesLoading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (isExpanded$ | async) {
  <div id="archive-items">
    @for (archive of displayedArchives$ | async; track archive) {
      @if ((showVersionsArchive$ | async) || archive.name !== 'Versions') {
        <app-navigation-archive
          [dbId]="database.id"
          [archive]="archive"
          (loadChildArchives)="onLoadChildArchives($event)"
        >
        </app-navigation-archive>
      }
    }
  </div>
}
